import React from 'react';

/**
 * Manage SKU Budgets tab content
 * Allows management of SKU-level budget allocations
 */
export function ManageSKUBudgets({ selectedFacility }) {
    return (
        <div>
            <div className="text-lg font-medium">Manage SKU Budgets for {selectedFacility?.name}</div>
            {/* Content will be built here */}
        </div>
    );
}
